import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_POST_SETTING, GET_POST_SETTING_SUCCESS, GET_POST_SETTING_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getPostSetting({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/adib/admin/app-settings`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_POST_SETTING_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_POST_SETTING_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_POST_SETTING_ERROR, payload: error });
  }
}

export function* watchGetPostSetting() {
  yield takeEvery(GET_POST_SETTING, getPostSetting);
}

function* getPostSettingSaga() {
  yield all([fork(watchGetPostSetting)]);
}

export default getPostSettingSaga;
